import React, { useEffect, useState } from 'react';
import { getAuditLogsApi, getAuditStatsApi } from '../api/audit.api';
import { apiHandler, unwrapData } from '../utils/apiHandler';
import { usePagination } from '../hooks/usePagination';
import Pagination from '../components/Pagination';
import PageHeader from '../components/PageHeader';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState(null);
  const [search, setSearch] = useState('');
  const {
    page,
    limit,
    loading,
    setLoading,
    applyPaginationMeta,
    paginationProps,
  } = usePagination(20);

  async function loadLogs(pageNum = page) {
    setLoading(true);
    const result = await apiHandler(() =>
      getAuditLogsApi({ page: pageNum, limit, action: search || undefined })
    );
    if (result.success) {
      const data = unwrapData(result);
      setLogs(data?.logs || []);
      applyPaginationMeta(data);
    }
    setLoading(false);
  }

  useEffect(() => {
    loadLogs(page);
    apiHandler(() => getAuditStatsApi()).then((r) => {
      if (r.success) setStats(unwrapData(r));
    });
  }, [page]);

  return (
    <>
      <PageHeader title="Audit Log" icon="fa-file-lines" trail={[{ label: 'Audit Log' }]} />
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
          <div className="stat-card">
            <div className="stat-num">
              {stats?.actionStats?.reduce((sum, row) => sum + Number(row.count || row.dataValues?.count || 0), 0) ?? '—'}
            </div>
            <div className="stat-label">Total events</div>
          </div>
        </div>
      )}
      <div className="section-card">
        <div className="cm-toolbar">
          <div className="cm-toolbar-start">
            <div className="cm-search-wrap">
              <i className="fas fa-magnifying-glass" aria-hidden />
              <input
                type="text"
                className="cm-search-input"
                placeholder="Filter by action…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && loadLogs(1)}
              />
            </div>
          </div>
          <div className="cm-toolbar-end">
            <button type="button" className="cm-apply-btn" onClick={() => loadLogs(1)}>
              <i className="fas fa-check" />
              Apply
            </button>
          </div>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Admin</th>
              <th>Action</th>
              <th>Target</th>
              <th>Summary</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5}>Loading…</td>
              </tr>
            ) : logs.length === 0 ? (
              <tr>
                <td colSpan={5}>No audit events</td>
              </tr>
            ) : (
              logs.map((e) => (
                <tr key={e.id}>
                  <td>{e.createdAt ? new Date(e.createdAt).toLocaleString() : '—'}</td>
                  <td>
                    {e.adminUser
                      ? `${e.adminUser.firstName || ''} ${e.adminUser.lastName || ''}`.trim()
                      : '—'}
                  </td>
                  <td>{e.action}</td>
                  <td>{e.targetType}</td>
                  <td>{e.summary}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <Pagination {...paginationProps} />
      </div>
    </>
  );
}
